import {
  findIndex, filter,
} from 'lodash';
import {
  CUSTOM_META_FETCH_ALL,
  CUSTOM_META_ADD_NEW_META,
  CUSTOM_META_DELETE_META,
} from './actions';

// Initial State
const initialState = {
  metas: [],
  indexedMetas: {},
  status: null,
  errors: null,
};

const MetaReducer = (state = initialState, action) => {
  switch (action.type) {
    case CUSTOM_META_FETCH_ALL: {
      const { metas, status, errors } = action;
      return {
        ...state,
        metas,
        status,
        errors,
      };
    }
    case CUSTOM_META_ADD_NEW_META: {
      const { meta, id } = action;
      const metas = [...state.metas];
      const existendIndex = findIndex(metas, { _id: id });
      if (existendIndex >= 0) {
        metas[existendIndex] = meta;
      } else {
        metas.push(meta);
      }
      return {
        ...state,
        metas,
      };
    }
    case CUSTOM_META_DELETE_META: {
      const { id } = action;
      const metas = filter(state.metas, m => m._id !== id);
      return {
        ...state,
        metas,
      };
    }
    default:
      return state;
  }
};

/* Selectors */
export const getAllMetas = state => state.customMetas.metas;
export const getAllMetasLoading = state => state.customMetas.status === 'loading';
export const getAllMetasLoaded = state => state.customMetas.status === 'loaded';
export const getAllMetasHasErrors = state => state.customMetas.status === 'error';
export const getAllMetasErrors = state => state.customMetas.errors;

// Export Reducer
export default MetaReducer;
